module.exports = __webpack_public_path__ + "media/14039.3cd0d1c8.mp3";